(function () {
  'use strict';

  var FILTER_PARAMS = [
    'filter.p.m.homland.need',
    'filter.p.m.homland.walker_style',
    'filter.p.m.homland.fit_support'
  ];

  var FILTER_ATTRS = {
    'filter.p.m.homland.need': 'hlSolutionNeed',
    'filter.p.m.homland.walker_style': 'hlSolutionStyle',
    'filter.p.m.homland.fit_support': 'hlSolutionFit'
  };

  function bind(root) {
    if (!root || root.dataset.hlSolutionQuizBound) return;
    root.dataset.hlSolutionQuizBound = 'true';

    var levels = Array.prototype.slice.call(root.querySelectorAll('[data-hl-solution-level]'));
    var visuals = root.querySelectorAll('[data-hl-solution-visual]');
    var progress = root.querySelector('[data-hl-solution-progress]');
    var progressFill = root.querySelector('[data-hl-solution-progress-fill]');
    var result = root.querySelector('[data-hl-solution-result]');
    var back = root.querySelector('[data-hl-solution-back]');
    var restartButtons = root.querySelectorAll('[data-hl-solution-restart]');
    var skip = root.querySelector('[data-hl-solution-skip]');
    var levelSelections = [];
    var selected = {};

    function setSelected(param, value) {
      if (!param || !value) return;
      if (!selected[param]) selected[param] = [];
      if (selected[param].indexOf(value) === -1) selected[param].push(value);
    }

    function removeSelected(param, value) {
      if (!param || !value || !selected[param]) return;
      selected[param] = selected[param].filter(function (item) { return item !== value; });
      if (!selected[param].length) delete selected[param];
    }

    function clearLevelSelection(index) {
      (levelSelections[index] || []).forEach(function (entry) {
        removeSelected(entry.param, entry.value);
      });
      levelSelections[index] = [];
    }

    function clearSelectionsAfter(index) {
      for (var levelIndex = levelSelections.length - 1; levelIndex > index; levelIndex -= 1) {
        clearLevelSelection(levelIndex);
      }
      levelSelections.length = index + 1;
    }

    function readUrlFilters() {
      var params = new URLSearchParams(window.location.search);
      selected = {};
      FILTER_PARAMS.forEach(function (param) {
        params.getAll(param).forEach(function (value) { setSelected(param, value); });
      });
    }

    function cardMatches(card, param, values) {
      var attr = FILTER_ATTRS[param];
      var raw = attr ? card.dataset[attr] || '' : '';
      var cardValues = raw.split('|').map(function (value) { return value.trim().toLowerCase(); }).filter(Boolean);
      return values.some(function (value) { return cardValues.indexOf(value.trim().toLowerCase()) !== -1; });
    }

    function applyClientFilters() {
      var grid = document.querySelector('.homland-prod-grid');
      if (!grid) return;
      var params = Object.keys(selected).filter(function (param) { return selected[param].length; });
      var visible = 0;
      grid.querySelectorAll('.homland-p-card').forEach(function (card) {
        var matches = params.every(function (param) { return cardMatches(card, param, selected[param]); });
        card.hidden = !matches;
        card.style.display = matches ? '' : 'none';
        if (matches) visible += 1;
      });
      var count = document.querySelector('[data-homland-result-count]');
      if (count) count.textContent = String(visible);
      var empty = document.querySelector('[data-homland-client-empty]');
      if (empty) empty.hidden = visible > 0;
    }

    function updateOptionCopy(button, option) {
      var label = button.querySelector('[data-hl-solution-option-label]');
      var helper = button.querySelector('[data-hl-solution-option-helper]');
      if (label && option.label) label.textContent = option.label;
      if (helper && option.helper) helper.textContent = option.helper;
      if (button.dataset.hlFilterParam !== undefined) button.dataset.hlFilterParam = option.param || '';
      if (button.dataset.hlFilterValue !== undefined) button.dataset.hlFilterValue = option.value || '';
      if (button.dataset.hlFilterParam2 !== undefined) button.dataset.hlFilterParam2 = option.param2 || '';
      if (button.dataset.hlFilterValue2 !== undefined) button.dataset.hlFilterValue2 = option.value2 || '';
      button.hidden = false;
      button.setAttribute('aria-hidden', 'false');
    }

    function applyContextualOptions(index) {
      var question = levels[index];
      if (!question) return;
      var collection = root.dataset.hlSolutionCollection || '';
      var need = (selected['filter.p.m.homland.need'] || [])[0] || '';
      var style = (selected['filter.p.m.homland.walker_style'] || [])[0] || '';
      var options = null;
      var fitParam = 'filter.p.m.homland.fit_support';
      var styleParam = 'filter.p.m.homland.walker_style';

      if (collection === 'mobility-support-solution') {
        if (index === 1) {
          if (need === 'Tight spaces') {
            options = [
              ['I need to turn easily through narrow rooms', 'Choose a compact format for doorways and frequent turns.', styleParam, '3-wheel rollators'],
              ['I prefer a lightweight frame for indoor routes', 'Keep everyday movement easy to steer and store.', styleParam, '3-wheel rollators'],
              ['I want a compact fold for storage', 'Prioritize a small footprint between uses.', styleParam, '3-wheel rollators']
            ];
          } else if (need === 'Upright walking') {
            options = [
              ['I want support that keeps me more upright', 'Start with forearm support for a taller walking position.', styleParam, 'Upright walkers'],
              ['I need to rest without giving up an upright posture', 'Keep a seated pause in an upright walking routine.', styleParam, 'Upright walkers'],
              ['I want to compare upright walking options', 'Review the fit and support range for a more upright walk.', styleParam, 'Upright walkers']
            ];
          } else if (need === 'Rest breaks') {
            options = [
              ['I want a comfortable seat for longer walks', 'A four-wheel rollator gives you a place to pause.', styleParam, '4-wheel rollators'],
              ['I need to switch between walking and riding', 'Compare a rollator that can also support assisted transport.', styleParam, 'Walker & wheelchair combos'],
              ['I want to rest while staying more upright', 'Consider forearm support with a built-in place to pause.', styleParam, 'Upright walkers']
            ];
          }
        } else if (index === 2) {
          if (style === '3-wheel rollators') {
            options = [
              ['I need easy turning in a small space', 'Keep the frame compact for narrow rooms and doorways.', fitParam, 'Compact fold'],
              ['I want a quick fold after each outing', 'Choose a format that is simple to put away.', fitParam, 'Compact fold'],
              ['I need lightweight storage between uses', 'Keep the daily setup easy to carry and store.', fitParam, 'Compact fold']
            ];
          } else if (style === '4-wheel rollators') {
            options = [
              ['I want a comfortable place to rest', 'Prioritize a padded seat for longer walks.', fitParam, 'Padded seat'],
              ['I want support behind my back while seated', 'Look for a backrest when taking a seated break.', fitParam, 'Backrest support'],
              ['I want to compare the seated support options', 'Review seat comfort and back support together.', fitParam, 'Padded seat', fitParam, 'Backrest support']
            ];
          } else if (style === 'Walker & wheelchair combos') {
            options = [
              ['I need a wider place to sit when riding', 'Compare the seat width for assisted transport.', fitParam, 'Extra-wide seat'],
              ['I want support behind my back while riding', 'Keep the seated position supported between stops.', fitParam, 'Backrest support'],
              ['I want to compare comfort and back support together', 'Review the two features that shape a seated ride.', fitParam, 'Extra-wide seat', fitParam, 'Backrest support']
            ];
          } else if (style === 'Upright walkers') {
            options = [
              ['I want a padded place to pause', 'Keep a comfortable seat within an upright walking setup.', fitParam, 'Padded seat'],
              ['I want support behind my back while seated', 'Add support when taking a seated break.', fitParam, 'Backrest support'],
              ['I want to compare seated upright support', 'Review seat comfort and back support together.', fitParam, 'Padded seat', fitParam, 'Backrest support']
            ];
          }
        }
      } else if (collection === 'bedside-care-solution-homland') {
        if (index === 1 || index === 2) {
          if (need === 'Transfer support') {
            options = [
              ['I need support while moving across', 'Keep the transfer path stable from one surface to the next.', fitParam, 'Transfer support'],
              ['I need the seat at a safer height', 'Use height support to make the transfer easier to manage.', fitParam, 'Height support'],
              ['I want transfer and height support together', 'Compare both parts of the setup before choosing.', fitParam, 'Transfer support', fitParam, 'Height support']
            ];
          } else if (need === 'Over-toilet support') {
            options = [
              ['I need the seat at the right height over the toilet', 'Match the commode height to the toilet and user.', fitParam, 'Height support'],
              ['I want a comfortable place to sit', 'Keep seated comfort central to the over-toilet setup.', fitParam, 'Seated support'],
              ['I want support behind my back while seated', 'Choose a back-supported commode when it helps.', fitParam, 'Back support']
            ];
          } else if (need === 'Bedside toileting') {
            options = [
              ['I need a stable place to sit beside the bed', 'Start with seated support for the bedside routine.', fitParam, 'Seated support'],
              ['I want support behind my back while seated', 'Keep the seated position comfortable and supported.', fitParam, 'Back support'],
              ['I need the seat at a manageable height', 'Adjust the setup to the user and bedside space.', fitParam, 'Height support']
            ];
          }
        }
      } else if (collection === 'recovery-mobility-solution-homland' && index === 1) {
        if (need === 'Post-injury mobility') {
          options = [
            ['I need to move without loading one leg', 'Use a knee-supported option for foot or ankle recovery.', styleParam, 'Knee scooters'],
            ['I want a simple frame to steady each step', 'Choose a standard frame for step-by-step support.', styleParam, 'Standard walkers'],
            ['I need a straightforward frame at home', 'Keep the recovery route simple with a folding frame.', styleParam, 'Standard walkers']
          ];
        } else if (need === 'Stable walking') {
          options = [
            ['I want a simple frame for each step', 'Keep balance support straightforward during recovery.', styleParam, 'Standard walkers'],
            ['I need a frame that stores easily at home', 'Prioritize a folding frame between routines.', styleParam, 'Standard walkers'],
            ['I want steady support without a seat', 'Choose a simple walking frame for daily movement.', styleParam, 'Standard walkers']
          ];
        } else if (need === 'Rest breaks') {
          options = [
            ['I want a seat for longer recovery walks', 'Choose a rollator with a place to pause.', styleParam, '4-wheel rollators'],
            ['I need to switch between walking and riding', 'Compare a walk-and-ride option for assisted transport.', styleParam, 'Walker & wheelchair combos'],
            ['I want to rest while staying more upright', 'Consider forearm support with a built-in seat.', styleParam, 'Upright walkers']
          ];
        }
      }

      if (!options) return;
      var buttons = question.querySelectorAll('[data-hl-solution-next]');
      options.forEach(function (option, optionIndex) {
        if (!buttons[optionIndex]) return;
        updateOptionCopy(buttons[optionIndex], {
          label: option[0], helper: option[1], param: option[2], value: option[3],
          param2: option[4], value2: option[5]
        });
      });
    }

    function buildResultsUrl() {
      var url = new URL(window.location.href);
      FILTER_PARAMS.forEach(function (param) { url.searchParams.delete(param); });
      Object.keys(selected).forEach(function (param) {
        selected[param].forEach(function (value) { url.searchParams.append(param, value); });
      });
      url.hash = root.dataset.hlSolutionAnchor || 'product-list';
      return url.toString();
    }

    function show(index, shouldFocus) {
      var isResult = index >= levels.length;
      var visualLevel = isResult ? levels[levels.length - 1] : levels[index];
      levels.forEach(function (level, levelIndex) {
        var active = !isResult && levelIndex === index;
        level.hidden = !active;
        level.classList.toggle('is-current', active);
      });
      visuals.forEach(function (visual) {
        var active = visual.dataset.hlSolutionVisual === (visualLevel && visualLevel.dataset.hlSolutionLevel);
        visual.classList.toggle('is-current', active);
        visual.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (result) {
        result.hidden = !isResult;
        result.classList.toggle('is-current', isResult);
      }
      if (progress) progress.textContent = isResult ? 'All questions complete' : 'Question ' + (index + 1) + ' of ' + levels.length;
      if (progressFill) progressFill.style.width = (isResult ? 100 : ((index + 1) / levels.length) * 100) + '%';
      if (back) back.hidden = index <= 0;
      root.dataset.hlSolutionIndex = String(index);
      if (!isResult) applyContextualOptions(index);
      if (shouldFocus !== false) {
        var focus = root.querySelector('.is-current [data-hl-solution-focus]');
        if (focus) focus.focus();
      }
    }

    function complete() {
      var resultsUrl = buildResultsUrl();
      window.history.pushState({ homlandSolutionQuiz: true }, '', resultsUrl);
      applyClientFilters();
      show(levels.length, false);
      window.setTimeout(function () {
        var anchor = document.getElementById(root.dataset.hlSolutionAnchor || 'product-list');
        if (anchor && anchor.scrollIntoView) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 120);
    }

    root.querySelectorAll('[data-hl-solution-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        var current = Number(root.dataset.hlSolutionIndex || '0');
        clearLevelSelection(current);
        var levelSelection = [];
        if (button.dataset.hlFilterParam && button.dataset.hlFilterValue) {
          setSelected(button.dataset.hlFilterParam, button.dataset.hlFilterValue);
          levelSelection.push({ param: button.dataset.hlFilterParam, value: button.dataset.hlFilterValue });
        }
        if (button.dataset.hlFilterParam2 && button.dataset.hlFilterValue2) {
          setSelected(button.dataset.hlFilterParam2, button.dataset.hlFilterValue2);
          levelSelection.push({ param: button.dataset.hlFilterParam2, value: button.dataset.hlFilterValue2 });
        }
        levelSelections[current] = levelSelection;
        if (current + 1 >= levels.length) complete();
        else show(current + 1);
      });
    });

    if (skip) {
      skip.addEventListener('click', function () {
        var current = Number(root.dataset.hlSolutionIndex || '0');
        clearLevelSelection(current);
        if (current + 1 >= levels.length) complete();
        else show(current + 1);
      });
    }

    if (back) {
      back.addEventListener('click', function () {
        var current = Number(root.dataset.hlSolutionIndex || '0');
        if (current <= 0) return;
        // A later answer must not remain active when the user revisits an
        // earlier level and chooses a different path.
        if (current < levels.length) clearSelectionsAfter(current - 1);
        show(Math.max(0, current - 1));
      });
    }

    restartButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        selected = {};
        levelSelections = [];
        var url = new URL(window.location.href);
        FILTER_PARAMS.forEach(function (param) { url.searchParams.delete(param); });
        url.hash = '';
        window.history.pushState({ homlandSolutionQuiz: true }, '', url.toString());
        applyClientFilters();
        show(0);
      });
    });

    readUrlFilters();
    applyClientFilters();
    // Do not move the viewport while the collection is loading. The hero
    // should remain the entry point; focus the next question only after a
    // user interaction, and let an existing #product-list hash win for a
    // deep-linked result state.
    if (Object.keys(selected).length) show(levels.length, false);
    else show(0, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hl-solution-quiz]').forEach(bind);
  }

  // Try immediately so a slow third-party resource cannot hold up the quiz;
  // the data guard makes the DOMContentLoaded retry safe when the section is
  // parsed later in the document.
  initAll(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
